module.exports = __webpack_public_path__ + "img/download2.373b9da4.png";